import {useEffect, useState} from 'react';
import {fetchIpData, IpData} from './ipGeolocationCache';

export function useIpGeolocation(fallbackCountry = 'in') {
    const [ipLocation, setIpLocation] = useState<IpData | null>(null);
    const [defaultCountry, setDefaultCountry] = useState(fallbackCountry);

    useEffect(() => {
        let alive = true;
        fetchIpData().then((data) => {
            if (alive) {
                setIpLocation(data);
                setDefaultCountry(data.country_code.toLowerCase());
            }
        });
        return () => {
            alive = false;
        };
    }, []);

    return {ipLocation, defaultCountry};
}
